module.exports = __webpack_public_path__ + "static/media/logo-halloween.28ed91ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-halloween.png
// module id = 67
// module chunks = 0